import React, { PropTypes } from "react";
import { findDOMNode } from "react-dom";
import { DragSource, DropTarget } from "react-dnd";
import flow from "lodash/flow";
import classNames from "classnames";

import { Render } from "../../../../../common";

class BlocClientsLineItem extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    const {
      client,
      isDragging,
      connectDragSource,
      connectDropTarget,
      connectDragPreview,
      blocId,
    } = this.props;
    const lineItemClasses = classNames({
      "bloc-client-line-item": true,
      checked: client.blocId === blocId && blocId !== null,
      unchecked: client.blocId === null,
      "is-dragging": isDragging,
      hidden: client.isArchived,
    });

    return connectDragPreview(
      connectDropTarget(
        <div className={lineItemClasses}>
          <div className="client-line">
            <Render if={!this.props.disabled}>
              {connectDragSource(<span className="drag-handle icon-move" />)}
            </Render>
            <span className="client-name">{client.name}</span>
          </div>
        </div>
      )
    );
  }
}

BlocClientsLineItem.propTypes = {
  disabled: PropTypes.bool,
};

const blocClientsSource = {
  beginDrag(props) {
    return {
      index: props.index,
      listId: props.listId,
      client: props.client,
    };
  },

  endDrag(props, monitor) {
    const item = monitor.getItem();
    const dropResult = monitor.getDropResult();

    if (dropResult && dropResult.listId !== item.listId) {
      props.removeClient(item.index);
    }
  },
};

const blocClientsTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;
    const sourceListId = monitor.getItem().listId;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Determine rectangle on screen
    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    // Determine mouse position
    const clientOffset = monitor.getClientOffset();

    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%

    // Dragging downwards
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }

    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }

    // Time to actually perform the action
    if (props.listId === sourceListId) {
      props.moveClient(dragIndex, hoverIndex);

      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      monitor.getItem().index = hoverIndex;
    }
  },
};

BlocClientsLineItem.propTypes = {
  connectDragPreview: PropTypes.func,
  connectDragSource: PropTypes.func,
  connectDropTarget: PropTypes.func,
  isDragging: PropTypes.bool,
  client: PropTypes.object,
  blocId: PropTypes.string,
};

export default flow(
  DropTarget("BLOC_CLIENT", blocClientsTarget, (connect) => ({
    connectDropTarget: connect.dropTarget(),
  })),
  DragSource("BLOC_CLIENT", blocClientsSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
  }))
)(BlocClientsLineItem);



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/blocs/bloc/clients/BlocClientsLineItem.js